import Swal, { SweetAlertOptions, SweetAlertResult } from "sweetalert2";

export const SwalFunction = async (
  title: string, // Title for the alert
  text: string, // Text to display in the alert
  confirmButtonText: string, // Text for the confirm button
  options?: SweetAlertOptions // Additional options for the alert (optional)
): Promise<SweetAlertResult<any>> => {
  const result = await Swal.fire({
    title: title,
    text: text,
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: confirmButtonText,
    ...options,
  });

  return result;
};
